module.exports = __webpack_public_path__ + "static/image4-ae26fbe58bdd6f8785a21a8d83b3eb72.jpg";